// Soft UI Dashboard React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";
import CoverLayout from "../components/CoverLayout";
import Checkmail from "./checkmail";
import useStore from "store/hook";
import { useState } from "react";
import useLogout from "services/Handlelogout";
import Formatmessage from "services/Formatmessage";
import { useForgotpasswordMutation } from "store/api/auth.api";
import { toast } from "react-toastify";
import schema from "validationSchema/forgotpassword";

function ForgotPassword() {
  const { store, setDialogue } = useStore();
  const [email, setEmail] = useState("");
  const [disabled, setDisabled] = useState(false);
  const [remaining, setRemaining] = useState(0);

  const logout = useLogout();

  const [forgotpassword, { isLoading, isSuccess, isError, error }] = useForgotpasswordMutation();

  // hadle form validation
  const validateForm = () => {
    const result = schema.safeParse({ email });

    if (!result.success) {
      const fieldErrors = result.error.flatten().fieldErrors;
      toast.error(fieldErrors.email ? fieldErrors.email[0] : "Invalid input");

      return false;
    } else {
      return true;
    }
  };

  // handle submit
  const handleSubmit = async () => {
    if (!validateForm()) return;

    const data = {
      email: email?.trim(),
      mode: "production",
    };

    try {
      const response = await forgotpassword(data).unwrap();
      if (response?.status == 1) {
        toast.success(Formatmessage(response?.message));
        setDialogue({
          type: "openCheckmail",
          isOpen: true,
          action: "",
          email: email,
        });
        localStorage.setItem("forgetPasswordMail", email);
        const disabledUntil = Date.now() + 2 * 60 * 1000;
        localStorage.setItem("buttonDisabledUntil", disabledUntil.toString());
        setDisabled(true);
        setRemaining(120);
      } else if (response?.status == 0) {
        toast.error(Formatmessage(response?.message));
      } else if (response?.status == 10) {
        logout();
      }
    } catch (error) {
      console.log("eror", error);
      toast.error("Server error. Please try again in a few minutes.");
    }
  };

  return (
    <CoverLayout isLogin={false}>
      <SoftBox
        width="100%"
        height="474px"
        borderRadius="xxl"
        overflow="hidden"
        sx={{ backgroundColor: "white.main" }}
        display="flex"
        flexDirection="column"
      >
        <SoftBox
          sx={{ boxSizing: "border-box", p: 0.5, backgroundColor: "secondary.main" }}
          borderRadius="xxl"
          width="100%"
        ></SoftBox>

        <SoftBox
          display="flex"
          sx={{
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: 4,
            width: "100%",
            flexGrow: 1,
          }}
        >
          <SoftBox
            display="flex"
            sx={{ px: 3, py: 1, flexDirection: "column", gap: 2, width: "100%" }}
          >
            <SoftBox
              width="100%"
              display="flex"
              sx={{
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
              }}
            >
              <SoftTypography sx={{ fontSize: 24, color: "black.main" }}>
                Forgot Password?
              </SoftTypography>

              <SoftBox sx={{ textAlign: "center" }}>
                <SoftTypography
                  sx={{
                    fontSize: 16,
                    color: "lightblack.main",
                    display: { xs: "inline", lg: "block" },
                  }}
                >
                  Enter your registered email address below, and we’ll
                </SoftTypography>
                <SoftTypography
                  sx={{
                    fontSize: 16,
                    color: "lightblack.main",
                    display: { xs: "inline", lg: "block" },
                  }}
                >
                  send you a link to reset your password.
                </SoftTypography>
              </SoftBox>
            </SoftBox>

            <SoftBox>
              <SoftBox sx={{ width: "100%" }}>
                <SoftBox
                  display="flex"
                  flexDirection="column"
                  alignItems="start"
                  justifyContent="center"
                  gap={1}
                  sx={{ width: "100%" }}
                >
                  <SoftTypography sx={{ fontSize: 16 }} color="darkgray" fontWeight="bold">
                    Email Address
                  </SoftTypography>

                  <SoftBox sx={{ position: "relative", width: "100%" }}>
                    <SoftInput
                      name="password"
                      type="text"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="Enter your email"
                      fontSize="14px"
                      sx={{
                        width: "100% !important",
                        py: "15px",
                      }}
                    />
                  </SoftBox>
                </SoftBox>
              </SoftBox>
            </SoftBox>
          </SoftBox>

          <SoftBox
            display="flex"
            sx={{
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              gap: 2,
              py: 2,
            }}
          >
            <SoftButton
              color="primary"
              disabled={isLoading}
              variant="contained"
              sx={{ textTransform: "capitalize", fontSize: 16, width: "200px" }}
              onClick={handleSubmit}
            >
              {isLoading ? "Loading..." : " Send Link"}
            </SoftButton>
          </SoftBox>
        </SoftBox>

        <SoftBox
          sx={{ boxSizing: "border-box", p: 0.5, backgroundColor: "secondary.main", mt: "auto" }}
          borderRadius="xxl"
          width="100%"
        ></SoftBox>
      </SoftBox>
      <Checkmail submit={handleSubmit} loading={isLoading} setEmail={setEmail} />
    </CoverLayout>
  );
}

export default ForgotPassword;
